import './looker-app.css';

import { FormRenderer } from '@wegolook/schema-form-renderer';
import React, { Component } from 'react';

class LookerAppContext extends Component {
  render() {
    return (
      <FormRenderer
        {...this.props}
        schema={this.props.editSchemaSchema}
        formValue={this.props.editSchemaPreview}
        onChange={this.props.onChange}
        renderContext="looker-app"
      />
    );
  }
}

export default LookerAppContext;
